import SubmitContext from 'context/submit/submitContext'
import PageContext from 'context/page/pageContext'
import DryBeansProduct from 'models/DryBeansProduct'
import React, { useContext, useEffect, useState } from 'react'
import Select from 'react-select'
import { Col, FormGroup, Input, Row, Alert } from 'reactstrap'
import { useFormUtils } from 'views/shared/useFormUtils'
import { beanTypeOptions, packagingInitialState } from './constants'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'

const DryBeansPackage = () => {
  const submitContext = useContext(SubmitContext)
  const pageContext = useContext(PageContext)

  const { current, setCurrent, updating } = submitContext
  const { setScrollToTop } = pageContext

  // eslint-disable-next-line no-unused-vars
  const [packaging, setPackaging] = useState(packagingInitialState)

  const { setSelect, asterisk } = useFormUtils()

  const methods = useFormContext()

  useEffect(() => {
    setScrollToTop(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (
      current?.category === packagingInitialState.category &&
      current?.subCategory === packagingInitialState.subCategory
    ) {
      const {
        category,
        subCategory,
        BeanPeaLentilType,
        BeanPeaLentilSize,
      } = current
      setPackaging({
        category,
        subCategory,
        BeanPeaLentilType: {
          value: BeanPeaLentilType || '',
          label: BeanPeaLentilType.length > 0 ? BeanPeaLentilType : 'Type',
        },
        BeanPeaLentilSize,
      })
    } else if (!updating) {
      setCurrent(DryBeansProduct)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current])

  return (
    <Row>
      <Col xs={4}>
        <p>
          <strong>Bean Type {asterisk}</strong>
        </p>
        <Controller
          as={Select}
          className="react-select primary"
          classNamePrefix="react-select"
          options={beanTypeOptions}
          name="BeanPeaLentilType"
          control={methods.control}
          rules={{ required: true }}
          placeholder={'Select Type'}
          onChange={([selected]) => {
            setSelect(selected, 'BeanPeaLentilType')
            return selected
          }}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="BeanPeaLentilType"
            message={'⚠ Bean type is required.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
        <br />
        <FormGroup>
          <p>
            <strong>Size {asterisk}</strong>
          </p>
          <Input value="16 ounces only" disabled />
        </FormGroup>
        <br />
      </Col>
    </Row>
  )
}

export default DryBeansPackage
